export const parseOrderByTime = (hour: number): string => {
  const isBcom = import.meta.env.VITE_ENTRY_POINT === 'bcom';

  if (!Number.isInteger(hour)) return '';

  const isPm = hour >= 12 && hour < 24;
  const hour12 = hour % 12 || 12;
  const dayPeriod = isPm ? 'pm' : 'am';

  return `Order by ${hour12}${isBcom ? dayPeriod.toUpperCase() : dayPeriod}`;
};

export default parseOrderByTime;
